import type { Lang, LorsCopy } from "./translations";

const baseEn = {
  eyebrow: "Free On-Demand Estate Planning Webinar",
  headline: "Estate Planning Basics — Watch Anytime, Free",
  headlineBreakBefore: "Watch Anytime, Free",
  subhead:
    "Watch our free on-demand webinar whenever it works for you. Attorney Ruby Steinbrecher shows you how California families use living trusts to keep their homes out of probate court — register and get instant access.",
  subheadLabel: "A note from Ruby:",
  learnTitle: "What Most California Homeowners Don't Realize Until It's Too Late",
  learnItems: [
    "Why a will alone won't keep your home out of California probate court",
    "How a properly funded living trust passes your home directly to your family — no court, no delays",
    "The 2025 California probate law changes and what they mean for Bay Area homeowners",
    "California probate fees on a $700,000 estate can exceed $46,000. A solid estate plan? A fraction of that — and your family gets everything, faster.",
  ],
  quote:
    "Ruby Steinbrecher was fantastic. The family trust workshop was clear, informative, and extremely helpful for getting started with estate planning.",
  quoteAttribution: "Shawn H., Workshop Attendee",
  formDate: { short: "Watch Anytime", long: "Available On-Demand" },
  formTime: "Watch at your convenience",
  formVenueLine1: "On-Demand Webinar",
  formVenueLine2: "Watch from anywhere — link sent after registration",
  formTitle: "Get Instant Access",
  formSubtitle: "Free to watch. Register and start watching right away.",
  formFirstName: "First name",
  formLastName: "Last name",
  formEmail: "Email",
  formPhone: "Phone",
  formSmsConsent:
    "I consent to receive text messages from the Law Office of Ruby Steinbrecher about this event, and occasional marketing messages. Message & data rates may apply. Text HELP for assistance, reply STOP to opt out.",
  formEnewsConsent:
    "I'd like to receive occasional email updates from the Law Office of Ruby Steinbrecher.",
  formPrivacy: "Privacy Policy",
  formSubmit: "Watch the Webinar",
  formSubmitting: "Getting your link…",
  formTrust: "⭐ Trusted by local families | 81 Five-Star Reviews",
  getDirections: "",
  footerCopyright: "© 2026 Ruby Steinbrecher",
  footerPrivacy: "Privacy Policy",
  testimonialsTitle: "What Families Are Saying",
  aboutTitle: "Meet Ruby Steinbrecher",
  aboutRole: "Attorney",
  aboutBody: [
    "I have practiced law since 2007, first working at a medium-sized firm in San Francisco handling civil litigation, and then moving into estate planning, small business and contract law since 2010. I value people, the planet, and prosperity that does not adversely affect the former.",
    "Prior to entering the legal field, I had a variety of business and life experience that has only enhanced my ability to serve clients: Road Manager for Ken Kesey's bus trip to Great Britain in 1999, Human Resources at a tech startup in 2001, recognized for my work as a Case Manager at Casey Family Programs with disadvantaged youth in the foster care system in Oakland and the wider San Francisco-Bay Area in the early 2000's.",
    "Currently, I live in Sebastopol with my daughter, husband, and a menagerie of pets, where I enjoy gardening as it keeps me grounded and enjoying the beautiful weather.",
  ],
  registrationTitle: "Ready to Secure Your Family's Future?",
  registrationSub: "Free to watch. Get instant access.",
  registrationCta: "Watch Now",
  registrationFoot:
    "No pressure. Just clear information so you can make the right decision for your family.",
  errorTitle: "Something went wrong",
  errorBody:
    "We couldn't get your link. Please try again or call our office.",
  validation: {
    firstName: "First name is required",
    lastName: "Last name is required",
    email: "Enter a valid email",
    phone: "Enter a valid phone number",
  },
  timeAgo: {
    monthAgo: "a month ago",
    monthsAgo: (n: number) => `${n} months ago`,
    yearAgo: "a year ago",
  },
};

export const lorsContentOnDemand = { en: baseEn, es: baseEn } as unknown as Record<Lang, LorsCopy>;

export const getOnDemandCopy = (): LorsCopy => baseEn as unknown as LorsCopy;
